import axios from 'axios';

import type { DownloadReportResponse } from './download.types';

async function getDownloadUrl(reportRequestId: string): Promise<DownloadReportResponse> {
  const response = await axios.get<DownloadReportResponse>(`/reporting/reports/${reportRequestId}/download`);
  return response.data;
}

export const downloadService = {
  getDownloadUrl,
};
